// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___d2b2ef0d2b97d27356b","cls2":"UserTaggingPingBodyStyles-cls2__c72664815e8f97bc6af6 UserTaggingPingBodyStyles-cls1___d2b2ef0d2b97d27356b"};